module.exports = __webpack_public_path__ + "img/icon_sec3_03.49c2f3e5.png";